import { Text, View } from '@react-pdf/renderer';

import styles from './Styles';

export const TAndC = ({ invoice }) => (
  <View style={{ marginTop: 2, paddingHorizontal: 7 }}>
    <Text style={styles.subTitle_plain}>Terms and Conditions:</Text>
    <Text style={{ ...styles.termsAndConditions_box, border: 'none' }}>
      {invoice.termsAndConditions}
    </Text>
  </View>
);
